module.exports = __webpack_public_path__ + "static/media/employee.bc94bf4c.jpg";